import { render, staticRenderFns } from "./DocumentInfoComponent.vue?vue&type=template&id=8c108984"
import script from "./DocumentInfoComponent.vue?vue&type=script&lang=js"
export * from "./DocumentInfoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports